import { Collection } from '@/state/Collection';
import { _NOTIFICATIONS } from "@/state";

import { UserNotificationsRoutes } from '@/repository/resources';
const { GetAllUnreadNotifications, MarkAllNotificationsAsRead, MarkNotificationAsRead } = UserNotificationsRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all		: Collection.stateDefaults(),
		_all 	: new Collection({statePath : 'userNotifications.all'}),
	},
	actions: {
		async index({ commit }, args) {
			try {
				let { page, per_page } = Object.assign({},args)
				let res = await GetAllUnreadNotifications({ page, per_page });
				commit('SET_UNREAD_NOTIFICATIONS_LIST', res.data);
			}
			catch (error) {
				console.error('Notifications could not be indexed.', error);
				throw error;
			}
		},
		async updateAllNotifcationsAsRead({ commit }) {
			try {
				await MarkAllNotificationsAsRead();
				commit('SET_UNREAD_NOTIFICATIONS_LIST',[]);
			}
			catch (error) {
				console.error('All Notifications could not be marked as read.', error);
				throw error;
			}
			
		},
		async updateNotifcationAsRead({ commit }, { notification }) {
			try {
				await MarkNotificationAsRead({ notification });
				commit('DELETE_NOTIFICATION', notification );
			}
			catch (error) {
				console.error('Notification could not be marked as read.', error);
				throw error;
			}	
		}
	},
	mutations: {
		SET_UNREAD_NOTIFICATIONS_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		PREPEND_SINGLE_NOTIFICATION_TO_LIST(state, obj) {
			state._all.items.prepend(obj).commitToState();
		},
		APPEND_MULTIPLE_NOTIFICATIONS_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		DELETE_NOTIFICATION(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		}
	}
}